import {defineExpenseOverrides, expenseDataModuleFactory} from '../utils/expense-data';

// noinspection JSUnusedGlobalSymbols
const overrides = defineExpenseOverrides({
   getters: {
      /**
       * Employees have no declaration concept (EmployeeProps has no `wasUsed` field —
       * every company has employees, so "did you use employees" is never a real
       * question). Declarations are permanently descoped for employees.
       */
      declaration() {
         return null;
      },
   },
   actions: {
      /**
       * Declarations are permanently descoped for employees (see the `declaration`
       * getter above) — there is no declare/`was_used` concept, so this stays a no-op.
       * `submit`/`unlock` now map to real server state via the factory defaults.
       */
      async saveDeclaration() {},
   },
});

export default expenseDataModuleFactory('employees', null, overrides);
